import { render, staticRenderFns } from "./GroupImport.vue?vue&type=template&id=61db19bb&scoped=true&"
import script from "./GroupImport.vue?vue&type=script&lang=js&"
export * from "./GroupImport.vue?vue&type=script&lang=js&"
import style0 from "./GroupImport.vue?vue&type=style&index=0&id=61db19bb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61db19bb",
  null
  
)

export default component.exports